import React from 'react';

export interface FilterChip {
  key: string;
  label: string;
  value: string;
  onClear: () => void;
}

interface IProps {
  chips: FilterChip[];
  onClearAll: () => void;
}

// Active-filter summary above a table: one chip per filter with an x, plus Clear all.
// Renders nothing when no filter is set.
const FilterBar: React.FC<IProps> = ({ chips, onClearAll }) => {
  if (!chips.length) return null;
  return (
    <div className="filter-bar">
      <span>Filters</span>
      {chips.map((chip) => (
        <span className="filter-chip" key={chip.key}>
          {chip.label}: <b>{chip.value}</b>
          <button
            type="button"
            className="filter-chip-x"
            aria-label={`Clear ${chip.label} filter`}
            onClick={chip.onClear}
          >
            ×
          </button>
        </span>
      ))}
      <button type="button" className="filter-clear-all" onClick={onClearAll}>
        Clear all
      </button>
    </div>
  );
};

export default FilterBar;
